export enum InternalCodeErrors {
  VERY_LARGE_FILTER = "Very large filter"
}
